import React from 'react';
import { useLocation } from 'react-router-dom';
import IconMail from '../../images/common/icon_mail.png';
import IconMail2x from '../../images/common/icon_mail@2x.png';

const Content = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search.slice(1));

  return (
    <div className="border_box text_list">
      <h2 className="curve_title">
        <img
          src={ IconMail }
          srcSet={ `${ IconMail } 1x, ${ IconMail2x } 2x`}
          alt="メールを送信いたしました"
        />
        メールを送信いたしました
      </h2>
      <p>
        Ton Bébéへようこそ
      </p>
      <p>
        ご登録いただいたメールアドレス({ params.get("email") })に仮登録完了のメールをお送りしました。
      </p>
      <p>
        メールに記載のURLにアクセスしていただき、本登録を完了してください。<br/>
        ※URLの有効期限は24時間です。
      </p>
      <p>
        しばらく経ってもメールが届かない場合、もしくは24時間以上経過した場合は、 再登録をお願いいたします。
      </p>
    </div>
  );
}

export default Content;
